
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsc30d8a3c5f3681e6180fa5db57fd94b5en from './en.yaml'
            i18n.addResourceBundle('en', 'c30d8a3c5f3681e6180fa5db57fd94b5', flattenObject(nsc30d8a3c5f3681e6180fa5db57fd94b5en), true, true);
        
        export default 'c30d8a3c5f3681e6180fa5db57fd94b5';
    